const MONITOR_LIST_SEARCH_KEY = 'bite-monitor:list-search';

// Saved by Monitor.tsx whenever its filters/page/view change, and read by
// AuditHeaderLayout's "Saved Work" breadcrumb so navigating out of a ticket
// returns to the same filtered, paginated list instead of a blank one.
// Monitor fully unmounts on that route change, so it can't hand this off via
// React state/props — sessionStorage is the only thing both sides can reach.
// sessionStorage can throw (SecurityError) when storage is disabled or blocked
// (private mode, sandboxed iframe, strict privacy settings). getMonitorListSearch
// runs during AuditHeaderLayout render, so an uncaught throw would break the whole
// header — degrade to "no restored filters" instead.
export const saveMonitorListSearch = (search: string): void => {
  try {
    sessionStorage.setItem(MONITOR_LIST_SEARCH_KEY, search);
  } catch {
    // Storage unavailable — restoring list state is best-effort.
  }
};

export const getMonitorListSearch = (): string => {
  try {
    return sessionStorage.getItem(MONITOR_LIST_SEARCH_KEY) || '';
  } catch {
    return '';
  }
};
